// extracted by mini-css-extract-plugin
module.exports = {"content":"content-1-o4c","footer":"footer-2dN76","button":"button-3FH2z","button_back":"button_back-1wBBl"};